import { SelectionState, EditorState, Modifier } from 'draft-js';

export const trimEditorContent = (editor: any) => {
  const editorState = editor;
  let currentContent = editorState.getCurrentContent();
  const firstBlock = currentContent.getBlockMap().first();
  const lastBlock = currentContent.getBlockMap().last();
  const firstBlockKey = firstBlock.getKey();
  const lastBlockKey = lastBlock.getKey();
  const firstAndLastBlockIsTheSame = firstBlockKey === lastBlockKey;

  const textStart = firstBlock.getText();
  const trimmedTextStart = textStart.trimLeft();
  const lengthOfTrimmedCharsStart = textStart.length - trimmedTextStart.length;

  let newSelection = new SelectionState({
    anchorKey: firstBlockKey,
    anchorOffset: 0,
    focusKey: firstBlockKey,
    focusOffset: lengthOfTrimmedCharsStart,
  });

  currentContent = Modifier.replaceText(currentContent, newSelection, '');

  let newEditorState = EditorState.push(
    editorState,
    currentContent,
    'adjust-depth',
  );

  let offset = 0;

  if (firstAndLastBlockIsTheSame) {
    offset = lengthOfTrimmedCharsStart;
  }

  const textEnd = lastBlock.getText();
  const trimmedTextEnd = textEnd.trimRight();

  newSelection = new SelectionState({
    anchorKey: lastBlockKey,
    anchorOffset: trimmedTextEnd.length - offset,
    focusKey: lastBlockKey,
    focusOffset: textEnd.length - offset,
  });

  currentContent = Modifier.replaceText(currentContent, newSelection, '');

  newEditorState = EditorState.push(
    editorState,
    currentContent,
    'adjust-depth',
  );

  return newEditorState;
};
